// extracted by mini-css-extract-plugin
module.exports = {"mainWindow":"style_mainWindow__33ovl","journeyContent":"style_journeyContent__1xZ8x","left":"style_left__2qYux","right":"style_right__3S4YM"};